import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolLpAction } from '@cbridge-packages/symbol-lp';

export const endSymbolLpProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolLpAction.create.failed,
    SymbolLpAction.update.failed,
    SymbolLpAction.remove.failed,
  ),
  mergeMap(() => {
    return [
      SymbolLpAction.processing.done({}),
    ];
  }),
);
